<template>
  <div>
    <div class="maintitle">部门列表</div>
    <el-divider></el-divider>
    <el-row class="text-left">
      <!-- <el-select v-model="crnttype" placeholder="请选择模板类型">
        <el-option label="员工考核" :value='1'></el-option>
        <el-option label="部门考核" :value='2'></el-option>
      </el-select> -->
      <el-button type="success" size="mini" @click="addDiv = true">添加新部门</el-button>
      <el-button type="success" size="mini" @click="saveSort">保存排序</el-button>
    </el-row>
    <el-table :data="list" row-key="value" border :tree-props="{ children: 'children',}">
      <el-table-column prop="label" label="部门名称"></el-table-column>
      <el-table-column prop="leader_name" label="负责人" width='80'></el-table-column>
      <el-table-column label="状态" width="60" :formatter="formatstatus"></el-table-column>
      <el-table-column label="操作" width="360" align="center">
        <template slot-scope="scope">
          <el-button type='text' @click="mdfy(scope)" size='mini'>修改</el-button>
          <el-button type='text' class="margin-small-left" @click="movePre(scope)" size='mini'>上移</el-button>
          <el-button type='text' class="margin-small-left" @click="moveNext(scope)" size='mini'>下移</el-button>
          <el-button type='text' class="margin-small-left" @click="addchild(scope)" size='mini'>添加子部门</el-button>
          <el-button type='text' class="margin-small-left" @click="setStatus(scope)" size='mini'>{{scope.row.status == 1 ? "停用" : "启用"}}</el-button>
          <el-button type='text' class="margin-small-left" @click="del(scope)" size='mini'>删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :visible.sync="addDiv" :show-close="false" @closed="resetFormInfo" :close-on-click-modal="false" @opened="initinfo">
      <el-form :model="departmentInfo" ref="departmentInfo">
        <el-form-item label="上级部门" :label-width="formLabelWidth" class="text-left">
          <div class="block">
            <el-cascader v-model="departmentInfo.path" :props="{ checkStrictly: true }" :show-all-levels="false" :options="list"></el-cascader>
          </div>
        </el-form-item>
        <el-form-item label="部门名称" :label-width="formLabelWidth">
          <el-input v-model="departmentInfo.label" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label='部门负责人' class="text-left" :label-width="formLabelWidth">
          <el-select v-model="departmentInfo.leader" placeholder="请选择负责人" filterable clearable>
            <el-option v-for="(item,index) in leaderlist" :key="index" :label="item.name+'('+item.department+')'" :value="item.uuid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="参与考核" class="text-left">
          <el-radio-group v-model="departmentInfo.kaohe">
            <el-radio-button label="1">参与</el-radio-button>
            <el-radio-button label="0">不参与</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="参与审核" class="text-left">
          <el-radio-group v-model="departmentInfo.shenhe">
            <el-radio-button label="1">参与下级成员审核</el-radio-button>
            <el-radio-button label="0">不参与下级成员审核</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="部门审核" class="text-left">
          <el-radio-group v-model="departmentInfo.depshenhe">
            <el-radio-button label="1">参与下级部门审核</el-radio-button>
            <el-radio-button label="0">不参与下级部门审核</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label='考核模板' class="text-left" :label-width="formLabelWidth" v-if="departmentInfo.kaohe==1">
          <el-select v-model="departmentInfo.tid" placeholder="请选择考核模板" filterable clearable>
            <el-option v-for="(item,index) in tpllist" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='允许查看' class="text-left" :label-width="formLabelWidth">
          <el-select v-model="departmentInfo.allowview" multiple placeholder="请选择允许查看的员工" filterable>
            <el-option v-for="(item,index) in leaderlist" :key="index" :label="item.name+'('+item.department+')'" :value="item.uuid"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item :label-width="formLabelWidth" label="状态" class="text-left" prop="status">
          <el-radio-group v-model="departmentInfo.status">
            <el-radio-button label="1">正常</el-radio-button>
            <el-radio-button label="0">停用</el-radio-button>
          </el-radio-group>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDiv = false;">取 消</el-button>
        <el-button type="primary" @click="submdfy">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [], //部门列表
      addDiv: false,
      departmentInfo: {
        value: 0,
        label: "",
        // status: 1,
        path: '',
        leader: '',
        allowview: [],
        tid: '',
        shenhe: 1,
        kaohe: 1,
        depshenhe: 1
      },
      crntpid: '',
      crntscope: "",
      leaderlist: [],
      showchildrendiv: false,
      tpllist: [],
      crntlist: [],
      crntDepList: [],
      tempinfo: {}
    };
  },
  methods: {
    getlist() {
      this.$axios({
        url: this.HOST + "/kaohe/department/getAllList",
        method: "post",
        data: {},
      }).then((res) => {
        if (res.data.status == 1) {
          this.list = res.data.list;
          this.leaderlist = res.data.leaderlist;
          this.tpllist = res.data.tpllist;
        }
      });
    },
    getBrother(list, id) {
      if (this.crntDepList.length > 0) return;
      if (id == 0) {
        return list;
      }
      for (let item in list) {
        if (list[item].value == id) {
          this.crntDepList = list[item].children;
        } else if (list[item].children) {
          this.getBrother(list[item].children, id);
        }
      }
    },
    formatstatus(row, column) {
      return row.status == 1 ? "正常" : "停用";
    },
    setStatus(scope) {
      let status = scope.row.status == 1 ? 0 : 1;
      this.$axios({
        url: this.HOST + "/kaohe/department/setStatus",
        method: "post",
        data: {
          info: {
            id: scope.row.value,
            status: status,
          },
        },
      }).then((res) => {
        if (res.data.status == 1) {
          scope.row.status = status;
        }
      });
    },
    //重置部门编辑对话框内容
    resetFormInfo() {
      this.crntscope = "";
      this.crntpid = "";
      for(let item in this.departmentInfo){
        this.departmentInfo[item] = this.tempinfo[item]
      }
    },
    mdfy(scope) {
      this.crntscope = scope;
      this.addDiv = true;
    },
    movePre(scope) {
      this.crntDepList = [];
      this.getBrother(this.list, scope.row.pid);
      // let templist = this.getBrother(this.list,scope.row.pid);console.log(this.getBrother(this.list,scope.row.pid));
      // this.getTemplist(scope);
      for (let item in this.crntDepList) {
        if (this.crntDepList[item].value == scope.row.value) {
          item = parseInt(item);
          if (item == 0) return;
          let temp = this.crntDepList.splice(item, 1);
          this.crntDepList.splice(item - 1, 0, temp[0]);
          return;
        }
      }
    },
    moveNext(scope) {
      this.crntDepList = [];
      this.getBrother(this.list, scope.row.pid);
      // let templist = this.getBrother(this.list,scope.row.pid);
      for (let item in this.crntDepList) {
        if (this.crntDepList[item].value == scope.row.value) {
          item = parseInt(item);
          if (item == this.crntDepList.length - 1) return;
          let temp = this.crntDepList.splice(item, 1);
          this.crntDepList.splice(item + 1, 0, temp[0]);
          return;
        }
      }
    },
    initinfo() {
      if (this.crntscope != "") {
        for (let item in this.departmentInfo) {
          if (item == 'path') {
            this.departmentInfo.path = this.crntscope.row.pid == 0 ? [0] : this.crntscope.row.pid;
          } else {
            this.departmentInfo[item] = this.crntscope.row[item];
          }
        }
      } else {
        this.departmentInfo.path = this.crntpid ? this.crntpid : [0];
      }
    },
    addchild(scope) {
      this.crntpid = scope.row.value;
      this.addDiv = true;
    },
    submdfy() {
      this.$axios({
        url: this.HOST + "/kaohe/department/saveDepartment",
        method: "post",
        data: {
          info: this.departmentInfo,
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.addDiv = false;
          this.getlist();
        }
      });
    },
    del(scope) {
      this.$confirm(
        '确定要删除部门"' +
        scope.row.label +
        '"吗？本操作会同步操作子部门并且不可恢复！！！',
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.$axios({
          url: this.HOST + "/kaohe/department/del",
          method: "post",
          data: {
            id: scope.row.value,
          },
        }).then((res) => {
          if (res.data.status == 1) {
            this.getlist();
            this.$message({
              type: "info",
              message: "操作成功",
            });
          }
        });
      });
    },
    saveSort() {
      this.$axios({
        url: this.HOST + '/kaohe/department/saveSort',
        method: 'post',
        data: {
          list: this.list
        }
      }).then(res => {
        if (res.data.status == 1) {
          this.$message({
            type: 'success',
            message: res.data.info
          })
          this.getlist();
        }
      })
    },
  },
  created: function () {
    for (let item in this.departmentInfo) {
      this.tempinfo[item] = this.departmentInfo[item]
    }
    this.getlist();
  },
};
</script>